import Swiper, {Navigation, Pagination, Autoplay} from 'swiper';

Swiper.use([Autoplay]);
Swiper.use([Pagination]);
Swiper.use([Navigation]);


import './parts/_navbar'
import './blocks/_hero-slider'
import './blocks/_categories-carousel'
import './blocks/_categories-card-carousel'
import './blocks/_linked-card-carousel'
import './blocks/_footer-logos-carousel'
import './blocks/_gmaps'